import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { formatPhoneLabel } from '@sluitstraat/core';
import { inboedelStyles as styles } from '../../../styles/commonStyles';

// The amber "cannot be insured" callout (monument / rented property), moved verbatim from
// InboedelScreen where the identical block appeared three times — only the element id and
// the title/message i18n keys differ. handleNext scrolls to the id when blocking navigation.

interface UninsurableWarningProps {
  id: string;
  titleKey: string;
  messageKey: string;
  contactInfo: { phone: string; email: string };
}

export const UninsurableWarning: React.FC<UninsurableWarningProps> = ({
  id,
  titleKey,
  messageKey,
  contactInfo,
}) => {
  const { t } = useTranslation();

  return (
    <div id={id} style={styles.monumentWarning}>
      <div style={styles.monumentWarningIcon}>
        <Info size={24} />
      </div>
      <div style={styles.monumentWarningContent}>
        <div style={styles.monumentWarningTitle}>
          {t(titleKey)}
        </div>
        <div style={styles.monumentWarningText}>
          {t(messageKey)}
        </div>
        {(contactInfo.phone || contactInfo.email) && (
          <div style={styles.monumentWarningContact}>
            {contactInfo.phone && (
              <div>
                <a href={`tel:${contactInfo.phone}`} style={styles.monumentWarningLink}>
                  {formatPhoneLabel(contactInfo.phone)}
                </a>
              </div>
            )}
            {contactInfo.email && (
              <div>
                <a href={`mailto:${contactInfo.email}`} style={styles.monumentWarningLink}>
                  {contactInfo.email}
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
